import { SxProps } from '@mui/material';
import { ExclamationMarkCircleIcon } from '@icons/ExclamationMarkCircleIcon';
import { colors } from '@constants/colors';

const classes = {
  root: {
    '& path': { fill: colors.grey_950 },
  },
};

export const ExclamationMarkCircleIconGrey = ({
  sx = {},
}: {
  sx?: SxProps;
}) => <ExclamationMarkCircleIcon sx={{ ...classes.root, ...sx }} />;
